<app-geometry-map
  [hideControls]="false"
  [zoom]="13"
  [hideLegend]="true"
  [center]="{
    lat: data.cmaReportData.subject?.Latitude,
    lng: data.cmaReportData.subject?.Longitude
  }"
  [multiPolygon]="data.polygons?.length > 0 ? data.polygons : []"
  [markerList]="data.markerList"
></app-geometry-map>
